import { Dictionary } from 'src/app/core/model/dictionary';

export class ContactHistory
{
    public id: number;
    public method: string;
    public entity: any;
    public activities: Dictionary[] = [];
    public areas: Dictionary[] = [];
    public initiative: any;
    public consent: any;
    public intensity: any;
    public sentiment: string;
    public comments: string;
    public memberId: number;
    public taskHistory: { id: string };
    public subject: string;
    public contactedOn: Date = new Date();
    public systemGenerated: boolean;
}
